import { apiClient } from "../client";
import type { PossibleGarbageResponse, PossibleGarbageStatus } from "../../types/possibleGarbage";

const BASE = "/api/admin/users/possible-garbage";

export const possibleGarbageService = {
  list: async (params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: PossibleGarbageStatus;
    onboarded?: boolean;
    schoolId?: string;
    campusId?: string;
  }): Promise<PossibleGarbageResponse> => {
    const query = new URLSearchParams();
    if (params.page) query.append("page", params.page.toString());
    if (params.limit) query.append("limit", params.limit.toString());
    if (params.search) query.append("search", params.search);
    if (params.status && params.status !== "all") query.append("status", params.status);
    if (params.onboarded !== undefined) query.append("onboarded", String(params.onboarded));
    if (params.schoolId) query.append("school_id", params.schoolId);
    if (params.campusId) query.append("campus_id", params.campusId);
    const response = await apiClient.get(`${BASE}?${query.toString()}`);
    return response.data;
  },

  warn: async (userIds: string[], hours: number): Promise<{ warned: number; pushed: number }> =>
    (await apiClient.post(`${BASE}/warn`, { user_ids: userIds, hours })).data,

  deactivate: async (userIds: string[]): Promise<{ deactivated: number }> =>
    (await apiClient.post(`${BASE}/deactivate`, { user_ids: userIds })).data,

  restore: async (userIds: string[]): Promise<{ restored: number }> =>
    (await apiClient.post(`${BASE}/restore`, { user_ids: userIds })).data,
};
